function extractIframeSrc(iframeString) {
  if (!iframeString || typeof iframeString !== "string") return null;

  const match = iframeString.match(/src=["']([^"']+)["']/);
  return match ? match[1] : null;
}

export default extractIframeSrc;
